import * as React from 'react'
import { connect } from 'react-redux'
import { Text, StackChildren, Icon } from '@doordash/design-language'
import {
  WaitlistContainer,
  InfoContainer,
  TitleContainer,
  HeaderTitle,
} from './styles'
import * as events from '../../../events'
import * as DA from '../../../typeModules/events'

import t from './strings'

type ReduxProps = {
  trackBottomOfFunnelWaitlist: (data: DA.BoFWaitlist) => Promise<any>
}

/**
 * Bottom-of-Funnel (BoF) Waitlist
 */
export const BoFWaitlist: React.FC<ReduxProps> = ({
  trackBottomOfFunnelWaitlist,
}) => {
  React.useEffect(() => {
    trackBottomOfFunnelWaitlist({
      action: DA.EventActions.Rendered,
    })
  }, [])

  return (
    <WaitlistContainer>
      <StackChildren>
        <TitleContainer>
          <HeaderTitle>{t.h1()}</HeaderTitle>
        </TitleContainer>
        <InfoContainer>
          <Icon size={Icon.Sizes.Large} type={Icon.Types.TimeFill} />
          <Text style={Text.Styles.Regular14}>{t.body()}</Text>
        </InfoContainer>
      </StackChildren>
    </WaitlistContainer>
  )
}

const mapDispatchToProps = {
  trackBottomOfFunnelWaitlist: events.trackBottomOfFunnelWaitlist,
}

export default connect(null, mapDispatchToProps)(BoFWaitlist)
